import UserActions from "../Types";
import responseHandler from "../../utils/responseHandler";
import Instance2 from "../../utils/apiCert";
import Instance from "../../utils/api";
import Storage from "../../utils/storage";
import Alert from "../../utils/Alert";

// UPLOAD POS DEVICE DOCS
export const uploadPosDeviceDocsStart = () => ({
  type: UserActions.UPLOAD_POS_DOC_START,
});

export const uploadPosDeviceDocsSuccess = (payload) => ({
  type: UserActions.UPLOAD_POS_DOC_SUCCESS,
  payload,
});

export const uploadPosDeviceDocsFailure = (payload) => ({
  type: UserActions.UPLOAD_POS_DOC_FAILURE,
  payload,
});

// UPLOAD POS DEVICE DETAILS
export const uploadPosDeviceDetailsStart = () => ({
  type: UserActions.REGISTER_DEVICE_START,
});

export const uploadPosDeviceDetailsSuccess = (payload) => ({
  type: UserActions.REGISTER_DEVICE_SUCCESS,
  payload,
});

export const uploadPosDeviceDetailsFailure = (payload) => ({
  type: UserActions.REGISTER_DEVICE_FAILURE,
  payload,
});

// APPLY FOR TEST CARD
export const applyForTestCardStart = () => ({
  type: UserActions.APPLY_FOR_TEST_CARD_START,
});

export const applyForTestCardSuccess = (payload) => ({
  type: UserActions.APPLY_FOR_TEST_CARD_SUCCESS,
  payload,
});

export const applyForTestCardFailure = (payload) => ({
  type: UserActions.APPLY_FOR_TEST_CARD_FAILURE,
  payload,
});

// PAYMENT GATEWAY
export const payForCertificationStart = () => ({
  type: UserActions.ADD_STAFF_START,
});

export const payForCertificationSuccess = (payload) => ({
  type: UserActions.ADD_STAFF_SUCCESS,
  payload,
});

export const payForCertificationFailure = (payload) => ({
  type: UserActions.ADD_STAFF_FAILURE,
  payload,
});

// GET TEST CARDS
export const getTestCardsStart = () => ({
  type: UserActions.GET_TEST_CARDS_START,
});

export const getTestCardsSuccess = (payload) => ({
  type: UserActions.GET_TEST_CARDS_SUCCESS,
  payload,
});

export const getTestCardsFailure = (payload) => ({
  type: UserActions.GET_TEST_CARDS_FAILURE,
  payload,
});

// GET USER TRAIL
export const getUserTrailStart = () => ({
  type: UserActions.GET_USER_TRAIL_START,
});

export const getUserTrailSuccess = (payload) => ({
  type: UserActions.GET_USER_TRAIL_SUCCESS,
  payload,
});

export const getUserTrailFailure = (payload) => ({
  type: UserActions.GET_USER_TRAIL_FAILURE,
  payload,
});

// GET ALL APPLICATIONS
export const getAllApplicationsStart = () => ({
  type: UserActions.GET_ALL_APPLICATIONS_START,
});

export const getAllApplicationsSuccess = (payload) => ({
  type: UserActions.GET_ALL_APPLICATIONS_SUCCESS,
  payload,
});

export const getAllApplicationsFailure = (payload) => ({
  type: UserActions.GET_ALL_APPLICATIONS_FAILURE,
  payload,
});

// RENEW POS APPLICATION
export const renewPosApplicationStart = () => ({
  type: UserActions.RENEW_POS_DOC_START,
});

export const renewPosApplicationSuccess = (payload) => ({
  type: UserActions.RENEW_POS_DOC_SUCCESS,
  payload,
});

export const renewPosApplicationFailure = (payload) => ({
  type: UserActions.RENEW_POS_DOC_FAILURE,
  payload,
});

//GET APPLICATION HASH VALUES
export const getApplicationHashStart = () => ({
  type: UserActions.GET_APPLICATION_HASH_START,
});

export const getApplicationHashSuccess = (payload) => ({
  type: UserActions.GET_APPLICATION_HASH_SUCCESS,
  payload,
});

export const getApplicationHashFailure = (payload) => ({
  type: UserActions.GET_APPLICATION_HASH_FAILURE,
  payload,
});

export const getCertificationAmountStart = () => ({
  type: UserActions.GET_CERTIFIATION_AMOUNT_START,
});

export const getCertificationAmountSuccess = (payload) => ({
  type: UserActions.GET_CERTIFIATION_AMOUNT_SUCCESS,
  payload,
});

export const getCertificationAmountFailure = (payload) => ({
  type: UserActions.GET_CERTIFICATION_AMOUNT_FAILURE,
  payload,
});

export const clearPosState = () => ({
  type: UserActions.CLEAR_POS_STATE,
});

// CHECK TERMINAL STATUS
export const checkTerminalStatusStart = () => ({
  type: UserActions.CHECK_TERMINAL_STATUS_START,
});
export const checkTerminalStatusSuccess = (payload) => ({
  type: UserActions.CHECK_TERMINAL_STATUS_SUCCESS,
  payload,
});
export const checkTerminalStatusFailure = (payload) => ({
  type: UserActions.CHECK_TERMINAL_STATUS_FAILURE,
  payload,
});

// RESET TERMINAL
export const resetTerminalStart = () => ({
  type: UserActions.RESET_TERMINAL_START,
});
export const resetTerminalSuccess = (payload) => ({
  type: UserActions.RESET_TERMINAL_SUCCESS,
  payload,
});
export const resetTerminalFailure = (payload) => ({
  type: UserActions.RESET_TERMINAL_FAILURE,
  payload,
});

export const checkTerminalStatus = (payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(checkTerminalStatusStart());
  try {
    const response = await API.post("/application/terminal-status", payload);
    const apiError = response.data?.data?.apiErrors?.apiErrorList?.[0]?.message;
    if (apiError) response.data.message = `${response.data.message}: ${apiError}`;
    responseHandler(response);
    if (response.ok) {
      Alert(response.data, "success", "Success", response.data.message);
      dispatch(checkTerminalStatusSuccess(response.data));
    } else {
      dispatch(checkTerminalStatusFailure(response.data));
    }
  } catch (error) {
    dispatch(checkTerminalStatusFailure(error.message));
  }
};

// export const resetTerminal = (payload) => async (dispatch) => {
//   const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
//   dispatch(resetTerminalStart());
//   try {
//     const response = await API.put("/application/terminal-reset", payload);
//     const apiError = response.data?.data?.apiErrors?.apiErrorList?.[0]?.message;
//     if (apiError) response.data.message = `${response.data.message}: ${apiError}`;
//     responseHandler(response);
//     if (response.ok) {
//       Alert(response.data, "success", "Success", response.data.message);
//       dispatch(resetTerminalSuccess(response.data));
//     } else {
//       dispatch(resetTerminalFailure(response.data));
//     }
//   } catch (error) {
//     dispatch(resetTerminalFailure(error.message));
//   }
// };

export const resetTerminal = (payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(resetTerminalStart());
  try {
    const response = await API.put("/application/terminal-reset", payload);
    // // console.log("===== RESET RESPONSE =====");
    // // console.log("response:", response);
    const apiError = response.data?.data?.apiErrors?.apiErrorList?.[0]?.message;
    if (apiError) response.data.message = `${response.data.message}: ${apiError}`;
    responseHandler(response);
    if (response.ok) {
      Alert(response.data, "success", "Success", response.data.message);
      dispatch(resetTerminalSuccess(response.data));
    } else {
      dispatch(resetTerminalFailure(response.data));
    }
    return response;
  } catch (error) {
    dispatch(resetTerminalFailure(error.message));
    throw error;
  }
};

// BULK UNLOCK TERMINALS
export const bulkUnlockTerminalsStart = () => ({ type: UserActions.BULK_UNLOCK_TERMINALS_START });
export const bulkUnlockTerminalsSuccess = (payload) => ({ type: UserActions.BULK_UNLOCK_TERMINALS_SUCCESS, payload });
export const bulkUnlockTerminalsFailure = (payload) => ({ type: UserActions.BULK_UNLOCK_TERMINALS_FAILURE, payload });
export const clearBulkUnlockResponse = () => ({ type: UserActions.CLEAR_BULK_UNLOCK_RESPONSE });
export const clearErrorResponse = () => ({ type: UserActions.CLEAR_ERROR_RESPONSE });

// export const bulkUnlockTerminals = (formData) => async (dispatch) => {
//   const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
//   dispatch(bulkUnlockTerminalsStart());
//   try {
//     const response = await API.post("/application/terminal-reset/bulk", formData);
//     responseHandler(response);
//     if (response.ok) {
//       // Alert(response.data, "success", "Success", response.data.message);
//       dispatch(bulkUnlockTerminalsSuccess(response.data));
//     } else {
//       dispatch(bulkUnlockTerminalsFailure(response.data));
//     }
//   } catch (error) {
//     dispatch(bulkUnlockTerminalsFailure(error.message));
//   }
// };

export const bulkUnlockTerminals = (formData) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(bulkUnlockTerminalsStart());

  try {
    const response = await API.post(
      "/application/terminal-reset/bulk",
      formData
    );

    // console.log("===== BULK UNLOCK RESPONSE =====");
    // console.log("response:", response);
    // console.log("response.ok:", response.ok);
    // console.log("response.status:", response.status);
    // console.log("response.data:", response.data);

    responseHandler(response);

    if (response.ok) {
      // console.log("DISPATCHING SUCCESS");
      Alert(response?.data, "success", "Success", response?.data?.message);
      dispatch(bulkUnlockTerminalsSuccess(response?.data));
    } else {
      // console.log("DISPATCHING FAILURE");
      dispatch(bulkUnlockTerminalsFailure(response?.data)); // || response?.message || "Bulk unlock failed"
      // Alert(response?.message)
    }
    return response;
  } catch (error) {
    // console.log("===== BULK UNLOCK ERROR =====");
    // console.log(error);
    dispatch(bulkUnlockTerminalsFailure(error?.message));
    throw error;
  }
};

// GET VIOLATION REASONS
export const getViolationReasonsStart = () => ({
  type: UserActions.GET_VIOLATION_REASONS_START,
});

export const getViolationReasonsSuccess = (payload) => ({
  type: UserActions.GET_VIOLATION_REASONS_SUCCESS,
  payload,
});

export const getViolationReasonsFailure = (payload) => ({
  type: UserActions.GET_VIOLATION_REASONS_FAILURE,
  payload,
});

export const getViolationReasons = () => async (dispatch) => {
  const API = Instance.customAxiosInstance(
    Storage.get("user-access-token")
  );

  dispatch(getViolationReasonsStart());

  try {
    const response = await API.get(
      "/application/violation-reasons"
    );

    responseHandler(response);

    if (response.ok) {
      dispatch(
        getViolationReasonsSuccess(response?.data)
      );
    } else {
      dispatch(
        getViolationReasonsFailure(response?.data)
      );
    }
  } catch (error) {
    dispatch(
      getViolationReasonsFailure(error?.message || error,)
    );
  }
};

export const uploadPosDeviceDocs = (payload) => async (dispatch) => {
  const API = Instance2.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(uploadPosDeviceDocsStart());
  API.post("certification/documents", payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(uploadPosDeviceDocsSuccess(data.data));
    } else {
      dispatch(uploadPosDeviceDocsFailure(data));
    }
  });
};

export const uploadPosDeviceDetails = (payload) => async (dispatch) => {
  const API = Instance2.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(uploadPosDeviceDetailsStart());
  API.post("certification", payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(uploadPosDeviceDetailsSuccess(data.data));
    } else {
      dispatch(uploadPosDeviceDetailsFailure(data));
    }
  });
};

export const applyForTestCard = (payload) => async (dispatch) => {
  const API = Instance2.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(applyForTestCardStart());
  API.post("certification/apply/card", payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(applyForTestCardSuccess(data));
    } else {
      dispatch(applyForTestCardFailure(data));
    }
  });
};

export const payForCertification = (payload) => async (dispatch) => {
  const API = Instance2.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(payForCertificationStart());
  API.post("certification/transaction", payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(payForCertificationSuccess(data.success));
    } else {
      dispatch(payForCertificationFailure(data));
    }
  });
};

export const getTestCards = () => async (dispatch) => {
  const API = Instance2.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(getTestCardsStart());
  API.get("certification/company/card").then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(getTestCardsSuccess(data.data));
    } else {
      dispatch(getTestCardsFailure(data));
    }
  });
};

export const getUserTrail = () => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(getUserTrailStart());
  API.get("/application/recent").then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(getUserTrailSuccess(data.data));
    } else {
      dispatch(getUserTrailFailure(data));
    }
  });
};

export const getAllApplications = () => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(getAllApplicationsStart());
  API.get("/application/pos").then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(getAllApplicationsSuccess(data.data));
    } else {
      dispatch(getAllApplicationsFailure(data));
    }
  });
};

export const renewPosDocs = (payload) => async (dispatch) => {
  const API = Instance2.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(renewPosApplicationStart());
  API.post("/certification/update", payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(renewPosApplicationSuccess(data.data));
    } else {
      dispatch(renewPosApplicationFailure(data));
    }
  });
};

export const getApplicationHash = (tid) => async (dispatch) => {
  try {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
  

    dispatch(getApplicationHashStart());

    const response = await API.get(`application/hash?tid=${tid}`);
    responseHandler(response);

    if (response.status === 400) {
      // Handle 400 error specifically
      dispatch(getApplicationHashFailure(response.data.apiErrors));
    } else if (!response.data || !response.data.requestSuccessful) {
      // Handle other errors
      dispatch(
        getApplicationHashFailure(
          response.data.apiErrors || "Failed to fetch application hash"
        )
      );
    } else {
      dispatch(getApplicationHashSuccess(response.data.responseBody));
    }
  } catch (error) {
    console.error("Error fetching application hash:", error.message);
    dispatch(getApplicationHashFailure(error.message));
  }
};




// GET COMPANY CERTIFICATES
export const getCertificatesStart = () => ({ type: UserActions.GET_CERTIFICATES_START });
export const getCertificatesSuccess = (payload) => ({ type: UserActions.GET_CERTIFICATES_SUCCESS, payload });
export const getCertificatesFailure = (payload) => ({ type: UserActions.GET_CERTIFICATES_FAILURE, payload });

export const getCertificates = () => async (dispatch) => {
  const API = Instance2.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(getCertificatesStart());
  try {
    const response = await API.get("certification/certificates");
    if (response.ok) {
      dispatch(getCertificatesSuccess(response.data.data));
    } else {
      dispatch(getCertificatesFailure(response.data));
    }
  } catch (error) {
    dispatch(getCertificatesFailure(error.message));
  }
};
